import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import { useState } from "react";
import { getPopupBorderRaduis, setMobileBackColor, setMobileCardBorderColor, setMobileTextColor } from "../../../utility";



const LoadingTreeDataDialog = ({ openTreeDialogFlag, tableName, tableQr }) => {
    const navigate = useNavigate();
    const [openFlag, setOpenFlag] = useState(openTreeDialogFlag || false);
    const handleClose = () => {
        setOpenFlag(false);
    };

    const redirectWelcome = () => {
        navigate(`/${tableName}/${tableQr}/menus`)
    }

    return (
        <Dialog
            open={openFlag}
            onClose={handleClose}
            fullWidth={true}
            maxWidth="xs"
            PaperProps={{
                sx: {
                    borderRadius: getPopupBorderRaduis(),
                    backgroundColor: setMobileTextColor(),
                    color: setMobileBackColor()
                },
            }}
            className="alignByLang"
        >
            <div className="p-24 text-center">
                <WarningAmberRoundedIcon
                    fontSize="large"
                    sx={{ fontSize: 80, color: setMobileBackColor() }}
                    color={setMobileBackColor()}
                    style={{ color: setMobileBackColor() }}
                />
                <DialogTitle className="p-0 text-center head-font">
                    {t("Error Loading Data")}
                </DialogTitle>
                <DialogContent className="p-0">
                    <DialogContentText style={{ color: setMobileBackColor() }} id="alert-dialog-slide-description">
                        <p className="text-center sub-font">
                            {t(
                                `This menu may not be available at this time,go to home screen to check the availabilities!`
                            )}
                        </p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{ backgroundColor: setMobileBackColor(), color: setMobileTextColor() }}
                        className="button-height-sm mx-1 head-font"
                        variant="contained"
                        onClick={redirectWelcome}
                        fullWidth
                    >
                        {t("Home")}
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
};

export default LoadingTreeDataDialog;
